import React from "react";

export function AnalyticsIncidentSkeleton() {
  return (
    <div
      className="analytics-incident-skeleton"
      aria-busy="true"
      aria-label="Загрузка списка инцидентов"
    >
      <div className="incident_row_container incident_header_row">
        <span className="incident_row_name_error">Ошибка</span>
        <span className="incident_row_name_count">Время простоя</span>
      </div>
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="analytics-incident-skeleton-row incident_row_container">
          <div
            className="analytics-skeleton-bar analytics-skeleton-bar--horizontal incident_list_skeleton_error"
            style={{ width: i % 2 === 0 ? "72%" : "58%" }}
          />
          <div
            className="analytics-skeleton-bar analytics-skeleton-bar--horizontal incident_list_skeleton_count"
            style={{ width: "40%" }}
          />
        </div>
      ))}
    </div>
  );
}
